class GroupImageCarousel {
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-items]');
        this.prevButton = el.querySelector('[data-prev]');
        this.nextButton = el.querySelector('[data-next]');
        this.navContainer = el.querySelector('[data-slider-nav]');
        this.slider = new Slider(this.scope, this.items, {controls:[this.prevButton, this.nextButton], navContainer:this.navContainer, count:[3, 4, 5], splitXs: true, gutter: 20});
    }
}

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-group-image-carousel]').forEach(el => new GroupImageCarousel(el));
})
